const headRowsCompany = {
  name: 'Company',
  email: 'E-mail',
  accountable: 'Responsible',
};

export default headRowsCompany;
